import { ReactNode, lazy } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import teaRoute from './tea'

const Profile = lazy(() => import('@/pages/Profile'))
const LoginHome = lazy(() => import('@/pages/Login'))
const Login = lazy(() => import('@/pages/Login/Login'))
const ForgotPwd = lazy(() => import('@/pages/Login/ForgotPwd'))

export interface RouteConfig {
	path: string
	element: ReactNode
	auth?: boolean
	name?: string
	children?: RouteConfig[]
	redirect?: string
}

// 路由映射表
const routes = [
	{
		path: '/tea',
		element: <Outlet />,
		auth: true,
		children: teaRoute
	},
	{
		path: '/login',
		element: <LoginHome />,
		children: [
			{ path: '', element: <Login />, title: '登录' },
			{ path: 'forgot', element: <ForgotPwd />, title: '记住密码' }
		]
	},
	{
		path: '/profile',
		auth: true,
		element: <Profile />
	},
	{
		path: '*',
		auth: true,
		element: <Navigate to="/tea" />
	}
]

export default routes
